import { SpringAnimator } from "@/mds";

interface DropdownAnimationProps {
  children: React.ReactNode | React.ReactNode[];
  innerStyle?: React.CSSProperties;
  skipAnimation?: boolean;
}

/**
 * @deprecated - Use the newer MDS components instead.
 *
 * - If something doesn't exist yet, please create a new MDS component and
 *   have it reviewed by the team!
 *
 * - If something needs to hook into our `stores`, add it to the /components directory.
 *
 * - If something is a one-off; please colocate it with the component/page that
 *   needs it.
 *
 * - If you have questions, please ask in the #hub-eng-web-team Slack channel.
 */
export function DropdownAnimation({
  children,
  innerStyle,
  skipAnimation = false,
}: DropdownAnimationProps) {
  if (skipAnimation) return children;
  return (
    <SpringAnimator
      innerStyle={{
        marginTop: "4px",
        transformOrigin: "top center",
        willChange: "transform",
        ...innerStyle,
      }}
    >
      {children}
    </SpringAnimator>
  );
}
